import {
  Stack, Typography, TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import EmptyImage from "../../Assets/empty-box.png"
//Srcs
import "./emptydata.scss";

export default function EmptyData({ colSpan }) {

  return (
    <>
      {colSpan ?
        <TableBody className="body">
          <TableRow className="body-row">
            <TableCell colSpan={colSpan} className="body-cell">
              <Stack direction="row" justifyContent="center" className="empty-container">
                <Stack direction="column" justifyContent="center" height="300px" spacing={1}>
                  <Stack direction="row" justifyContent="center">
                    <img src={EmptyImage} alt="icon" className="empty-image" />
                  </Stack>
                  <Typography className="text-title">មិនមានទិន្នន័យ</Typography>
                </Stack>
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
        : (<Stack direction="row" justifyContent="center" className="empty-container">
          <Stack direction="column" justifyContent="center" height="300px" spacing={1}>
            <Stack direction="row" justifyContent="center">
              <img src={EmptyImage} alt="icon" className="empty-image" />
            </Stack>
            <Typography className="text-title">មិនមានទិន្នន័យ</Typography>
          </Stack>
        </Stack>)
      }
    </>
  )
}

export function EmptyTr({ colSpan }) {
  return (
    <tr>
      <td colSpan={colSpan}>
        <Stack direction="column" justifyContent="center" alignItems='center' height="200px" spacing={1}>
          <img src={EmptyImage} alt="icon" style={{ width: '100px' }} />
          <Typography sx={{ fontWeight: 'bold' }}>មិនមានទិន្នន័យ</Typography>
        </Stack>
      </td>
    </tr>
  )
}